import Color from './Color';
import TextStrings from './textStrings';
import ImageAssets from './ImageAssets';
import Formats from './Formats';
import KeyFrames from './KeyFrames';
import Localization from './Localization';
import changeLogEN from './changelogs/changelog.en.md';
import changeLogNL from './changelogs/changelog.nl.md';
import changeLogDE from './changelogs/changelog.de.md';
import changeLogFR from './changelogs/changelog.fr.md';
import disclaimerEN from './disclaimers/disclaimer.en.md';
import disclaimerNL from './disclaimers/disclaimer.nl.md';
import disclaimerDE from './disclaimers/disclaimer.de.md';
import disclaimerFR from './disclaimers/disclaimer.fr.md';

export default {
  Color,
  TextStrings,
  ImageAssets,
  Formats,
  KeyFrames,
  Localization,
  changeLogEN,
  changeLogNL,
  changeLogDE,
  changeLogFR,
  disclaimerEN,
  disclaimerNL,
  disclaimerDE,
  disclaimerFR,
};
